import localforage from "localforage";
export const BotWorkStationBar = localforage.createInstance({
  name: "BotWorkStationBar"
});
export const PublicSentimentNavigationBar = localforage.createInstance({
  name: "PublicSentimentNavigationBar"
});
export const publisherNavigationBar = localforage.createInstance({
  name: "PublisherNavigationBar"
});

/**
 * 存储舆情社媒监控媒体账号列表列
 * @type {LocalForage}
 */
export const localforageDialogSocialColumnConfig = localforage.createInstance({
  name: "DialogSocialColumnConfig"
});

/**
 * 新建群发任务表单草稿（365 OAuth 跳转前后缓存文件类字段，File 对象走 IndexedDB）
 * @type {LocalForage}
 */
export const massEmailTaskDraft = localforage.createInstance({
  name: "MassEmailTaskDraft"
});